import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Box } from "@mui/material";

import {
  useWorkflowThree,
  generateWfOnePdfReportbyId,
} from "../../../../../libs/apis";
import { WorkflowThreeI } from "../../../../../libs/interfaces";
import { SendReport } from "../../../../../libs/shared";
import { DashboardTable } from "./dashboard-table";
import type { ColumnsType } from "antd/es/table";
import { useWidth } from "../../../../../libs/hooks";
import { useNavigate } from "react-router-dom";
import "../../../../../libs/css/list.css";
import { Button as ButtonAntd, Tooltip as TooltipAntd, message } from "antd";
import {
  FilePdfOutlined,
  FundViewOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { ShowContainer } from "../../../../../components/workflow-three/components/list/show-container";

const titleExport = "Flujos";
const routeEdit = "/workflow/three/edit/";

const WorkflowThreeListComponent = () => {
  const width = useWidth();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [sorting, setSorting] = useState([{ id: "id", desc: true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: width === "ab" ? 25 : width === "xl" ? 20 : 15,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const { workflowThreesQuery } = useWorkflowThree({
    sorting,
    pagination,
    globalFilter,
  });
  const { data, isLoading, refetch, isRefetching } = workflowThreesQuery;
  const [rowSelection, setRowSelection] = useState({});

  const [isGeneratingPdf, setGeneratingPdf] = useState(false);



  const columns = useMemo<ColumnsType<WorkflowThreeI>>(
    () => [
      {
        title: "N° Contenedor",
        dataIndex: "container",
        width: 160,
        render: (value: string, row: WorkflowThreeI) => (
          <a className="b-proform" onClick={() => handleNavigate(row)}>
            {value}
          </a>
        ),
      },
      { title: "N° Etiqueta", dataIndex: "labelSerial", width: 140 },
      {
        title: "Hora Inicio",
        dataIndex: "startProcess",
        width: 110,
        responsive: ["md"],
      },
      {
        title: "Hora Final",
        dataIndex: "endProcess",
        width: 110,
        responsive: ["md"],
      },
      {
        title: "Creación",
        dataIndex: "createdAt",
        width: 160,
        responsive: ["sm"],
      },
    ],
    []
  );




  const handleNavigate = useCallback((row: WorkflowThreeI) => {
    const routePath = routeEdit + row.id;
    navigate(routePath);
  }, []);

  const handlePdf = async (row: WorkflowThreeI) => {
    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 20,
      });

      const { data: dataPdf } = await generateWfOnePdfReportbyId(row.id!);
      messageApi.destroy("generatePdfKey1");
      messageApi.open({
        key: "generatePdfKey4",
        type: "loading",
        content: "Procesando Pdf",
        duration: 1,
        onClose: () => {
          message.success("PDF Descargado", 1);
        },
      });

      const downloadLink = document.createElement("a");
      downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
      downloadLink.target = "__blank";
      downloadLink.download = `Reporte-Proceso-1-${row.container}.pdf`;
      downloadLink.click();
      setGeneratingPdf(false);
    } catch (err: any) {
      messageApi.destroy();
      setGeneratingPdf(false);
      message.error(`Error al generar el pdf: ${err.toString()}`);
    }
  };


  const handleOpenExternal = (row: WorkflowThreeI) => {
    navigate(`/exterior/workflow-three/${row.id}`);
  };

  return (
    <Fragment>
      {contextHolder}
      <DashboardTable<WorkflowThreeI>
        columns={columns}
        data={data?.data?.dato ?? []}
        total={data?.data?.total ?? 0}
        loading={isLoading || isRefetching}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        setGlobalFilter={setGlobalFilter}
        onRefresh={() => refetch()}
        exportTitle="Flujos"
        actionsWidth={140}
        renderActions={(row) => (
          <Box sx={{ display: "flex", gap: "0.4rem", justifyContent: "center" }}>
            <ButtonAntd
              loading={isGeneratingPdf}
              disabled={isGeneratingPdf}
              size="small"
              onClick={() => handlePdf(row)}
              icon={<FilePdfOutlined />}
              danger
            />
          <ShowContainer id={row.id!} />
          <SendReport id={row.id!} typeWf="three" />
            <TooltipAntd arrow={false} title="Link Externo">
              <ButtonAntd
                size="small"
                type="dashed"
                onClick={() => handleOpenExternal(row)}
                icon={<GlobalOutlined />}
              />
            </TooltipAntd>
          </Box>
        )}
      />
    </Fragment>
  );
};

export default WorkflowThreeListComponent;
